package com.tovtalk.utils.config

/**
 * Hadran is Android-only. Web always returns false.
 */
actual fun isHadranDevice(): Boolean = false
